import { render, staticRenderFns } from "./PaymentSection.vue?vue&type=template&id=ba1f6460&scoped=true&"
var script = {}
import style0 from "./PaymentSection.vue?vue&type=style&index=0&id=ba1f6460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1f6460",
  null
  
)

export default component.exports